<script>
import { mapState } from "vuex"
import { isMobile } from 'mobile-device-detect'
import Placa from '@/components/alerta/VPlaca'
import Cores from '@/components/alerta/VCores'
import DataInicial from '@/components/alerta/VDataInicial'
import DataFinal from '@/components/alerta/VDataFinal'
import BtnSalvar from '@/components/alerta/VBtnSalvar'
import BtnAlterar from '@/components/alerta/VBtnAlterar'
import Consultar from '@/components/alerta/VConsultar'

export default {
  name: 'CadastroAlerta',
  props: { 
  },
  components: {
    Placa,
    Cores,
    DataInicial,
    DataFinal,
    BtnSalvar,
    BtnAlterar,
    Consultar
  },
  data () {
    return {
      isMobile: isMobile,
      idState: null,
      btnAlterarEnable: true,
      btnNovoEnable: true,
      btnCancelarEnable: false,
      btnBuscarAlertaVsible: false,
    }
  },
  computed: { 
    ...mapState({
      user: state => state.moduleLogin.user,
      usuario: state => state.moduleLogin.usuario,
      clientinfo: state => state.moduleLogin.clientinfo,
      alerta: state => state.moduleAlerta.alerta,
      idTelegram: state => state.moduleTelegram.idTelegram
    }),
  },
  mounted (){
    this.$store.dispatch("BUSCATELEGRAM", {codigoUsuario: this.usuario.codUsuario, cidade: this.user.cidade})
  },
  methods: {
    btnNovo() {
      if (this.idTelegram == ''){
        this.$swal.fire({
            title: "Cadastrar o Alerta",
            text: 'Necessario o cadastro no Telegram',
            icon: "error"
          })
          return
      }

      this.alerta.estado = 'novo'
      this.btnNovoEnable = false
      this.btnAlterarEnable = false
      this.btnCancelarEnable = true
    },
    btnAlterar() {
      if (this.idTelegram == ''){
        this.$swal.fire({
            title: "Cadastrar o Alerta",
            text: 'Necessario o cadastro no Telegram',
            icon: "error"
          })
          return
      }

      this.alerta.estado = 'alterar'
      this.btnNovoEnable = false
      this.btnAlterarEnable = false
      this.btnCancelarEnable = true 
    },
    btnCancelar() {
      this.alerta.estado = ''
      this.btnNovoEnable = true
      this.btnAlterarEnable = true
      this.btnCancelarEnable = false
      this.limparCampos()
    },
    limparCampos(){
      this.alerta.estado = ''
      this.alerta.placa = ''
      this.alerta.cor = 'AMARELA'
      this.alerta.modelo = ''
      this.alerta.dataInicial = ''
      this.alerta.dataFinal = ''
      this.alerta.idTelegram = []
      this.alerta.tipoAlerta = ''
      this.alerta.recomendacao = ''
      this.alerta.detalhe = ''
      this.alerta.codOcorrencia = 0
      this.btnNovoEnable = true
      this.btnAlterarEnable = true
      this.btnCancelarEnable = false
    }
  },
}
</script>

<template>
  <b-container class="container">
    <div class="textoFiltros">Cadastro Alerta</div>
    <b-row>
      <b-col cols=12 md="6"> <!-- primeira coluna -->
        <b-row class="text-left" align-v="center">
          <b-col class="separador" cols="12">
            <div>Funções</div>
            <b-row>
              <b-col cols="12">
                <b-button class="separador_botao" :disabled='!btnNovoEnable' @click='btnNovo' :variant="btnNovoEnable ? 'success' : ''">Novo</b-button>
                <b-button class="separador_botao" :disabled='!btnAlterarEnable' @click='btnAlterar' :variant="btnAlterarEnable ? 'warning' : ''">Alterar</b-button>
                <b-button class="separador_botao" :disabled='!btnCancelarEnable' @click='btnCancelar' :variant="btnCancelarEnable ? 'danger' : ''">Cancelar</b-button>
                <Consultar class="separador_botao"/>
              </b-col>
            </b-row>
          </b-col>
          <b-col class="separador" cols="12">
            <div>Veiculos</div>
            <b-row>
              <b-col cols="6">
                <Placa :ativar='btnNovoEnable'/>
              </b-col>
              <b-col cols="6">
                <Cores :ativar='alerta.estado == "novo_ativo" || alerta.estado == "alterar_ativo"' />
              </b-col>
              <b-col cols="12">
                <b-form-text>Modelo:</b-form-text>
                <b-form-input class="shadow rounded" v-model="alerta.modelo" :readonly='!(alerta.estado == "novo_ativo" || alerta.estado == "alterar_ativo")'/>
              </b-col>
            </b-row>
          </b-col>
          <b-col class="separador" cols="12">
            <div>Tempo do alerta Ativo</div>
            <b-row>
              <b-col cols="6">
                <DataInicial :ativar='!(alerta.estado == "novo_ativo" || alerta.estado == "alterar_ativo")'/>
              </b-col>
              <b-col cols="6">
                <DataFinal :ativar='!(alerta.estado == "novo_ativo" || alerta.estado == "alterar_ativo")'/>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols=12 md="6"> <!-- segunda coluna -->
          <b-row class="text-left" align-v="center">
            <b-col class="separador" cols="12">
            <div>Comunicação</div>
            <b-row>
              <b-col cols="12">
                <b-form-text>ID Telegram (adicional): {{ idTelegram == '' ? 'não possui cadastro telegram' : idTelegram}}</b-form-text>
                <b-form-tags input-id="tags-pills" v-model="alerta.idTelegram" tag-variant="primary" tag-pills separator=" " placeholder="Adicionar ID Telegram" addButtonText="+"	
                             input-type="number" :disabled='!(alerta.estado == "novo_ativo" || alerta.estado == "alterar_ativo")'/>
              </b-col>
            </b-row>
          </b-col>
            <b-col class="separador" cols="12">
              <div>Informações</div>
              <b-row>
                <b-col cols="12">
                  <b-form-text>Tipo Alerta:</b-form-text>
                  <b-form-input class="shadow rounded" v-model="alerta.tipoAlerta" :readonly='!(alerta.estado == "novo_ativo" || alerta.estado == "alterar_ativo")'/>
                </b-col>
                <b-col cols="12">
                  <b-form-text>Recomendação:</b-form-text>
                  <b-form-input class="shadow rounded" v-model="alerta.recomendacao" :readonly='!(alerta.estado == "novo_ativo" || alerta.estado == "alterar_ativo")'/>
                </b-col>
                <b-col cols="12">
                  <b-form-text>Detalhe:</b-form-text>
                  <b-form-input class="shadow rounded" v-model="alerta.detalhe" :readonly='!(alerta.estado == "novo_ativo" || alerta.estado == "alterar_ativo")'/>
                </b-col>
              </b-row>
            </b-col>
            <b-col class="separador" cols="12" v-show="alerta.estado != ''">
              <b-row>
                <b-col cols="12" v-if="(alerta.estado == 'novo_ativo' || alerta.estado == 'novo') && alerta.codOcorrencia == 0">
                  <BtnSalvar :ativar='!(alerta.estado == "novo_ativo" || alerta.estado == "alterar_ativo")' @limparCampos='limparCampos'/>
                </b-col>
                <b-col cols="12" v-else>
                  <BtnAlterar :ativar='btnAlterarEnable' @limparCampos='limparCampos'/>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<style scoped>
  .separador_botao{
    margin-left: 5px;
    margin-top: 5px;
  }
  .separador{
    padding: 15px;
    color: #000000
  }
  .textoFiltros {
    font-weight: bold;
    color: #2c3e50;
    left: 0;
    text-align: left;
    padding-top: 1.5vh;
  }
</style>
